<template>
  <div class="search-holder" :class="{sel: tfocus}">
    <div class="search-widget">
      <input type="email" class="search-area" :placeholder="$nippets.subscribeText" 
        v-on:focus="setFocused(true)" v-on:blur="setFocused(false)" v-model="email" v-on:keyup.enter="handleGo" />
      <div class="go-area" :class="{canGo: canGo}" v-on:click="handleGo">{{ $nippets.search.go }}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    right: Boolean
  },
  data: function () {
    return {
      tfocus: false,
      email: '',
      selItem: { kind: 'none', value: {}},
      mheight: 400
    }
  },
  computed: {
    canGo () {
      return this.$k.validEmail(this.email)
    }
  },
  
  methods: {
    setFocused: function (f) {
      if(!f){
        this.tfocus = false
      }
      else {
        this.tfocus = true
      }
    },
    handleGo: async function () {
      try {
        if(this.$k.validEmail(this.email)) {
          await this.$store.dispatch('subscribe', this.email)
          this.$k.sendGaEvent('Newsletter','Subscribe', this.$route.path)
          this.$k.messageBox(this.$nippets.subscribe, this.$nippets.subscribeThanks)
          this.$k.logVisit('Newsletter subscribe', this.email)
        }
        else {
          this.$k.messageBox(this.$nippets.subscribe, this.$nippets.invalidEmail)
        }
        
      }
      catch(err) {
        this.$k.messageBox(this.$nippets.subscribe, err.message)
      }

    }
  }
  
}
</script>

<style scoped>
h3{
  font-size:18px;
  font-weight:500;
  margin:0 0 10px 0;
  padding-left:16px;
}
.search-holder{
  display:inline-block;
  position:relative;

}

.narex .search-holder{
  margin-right:-20px;
}

.search-widget {
  border-radius:6px;
  border:1px solid #c8c8c8;
  background-color:#fff;
  display:inline-flex;
  overflow:hidden;
}


.search-widget:hover{
  border-color:#888;
}

.sel .search-widget{
  border-color:#444;
}

.search-col{
  margin:10px;
  line-height:26px;
  text-align:left;
}

.search-area{
  padding:10px;
  font-size:14px;
  line-height:16px;
  font-weight:400;
  color:#666;
  min-width:190px;
  width:12vw;
  border:0;
}

.go-area{
  background-color:#a7aba1;
  color:#fff;
  font-size:17px;
  line-height:16px;
  font-weight:500;
  padding:10px;
  text-transform:uppercase;
  user-select: none;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.go-area.canGo{
  cursor:pointer;
  background-color:#ce0e2d;
}

.go-area.canGo:hover{
  background-color:#000;
}




</style>
